module.exports = __webpack_public_path__ + "img/250460827_2025_2-1.c7cab9b7.png";